module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_37-bc717e55a1737b718282dc494ef9e76b.png";